import type { ComponentProps } from 'react'
import { useEffect, useState } from 'react'
import { useLocation } from 'wouter'
import { MapPage } from './MapPage'

// El mapa no se desmonta al ir a otra pantalla: se queda oculto y, al volver, está igual que
// se dejó (sin recargar el estilo, las teselas ni los datos). Solo se crea la primera vez que
// se entra en el mapa: quien llega por el QR de un árbol no descarga MapLibre.
export const KeptMap = ({ Canvas }: Pick<ComponentProps<typeof MapPage>, 'Canvas'>) => {
	const [location] = useLocation()
	const active = location === '/'
	const [visited, setVisited] = useState(active)
	useEffect(() => {
		if (active) setVisited(true)
	}, [active])
	if (!visited && !active) return null
	return <MapPage Canvas={Canvas} active={active} />
}
